import { Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'em-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  standalone: false,
})
export class ConfirmationComponent {
  private dialogRef = inject(DialogRef);
  data = inject<{
    title: string;
    message: string;
}>(DIALOG_DATA);


  public close(value: boolean = false): void {
    this.dialogRef.close(value);
  }
}
